import {AccountCreateStep, TSignupSteps} from '@/sites/account-default/typedef'

export const findActiveStepIndex = (
  steps: TSignupSteps,
  currentStep: AccountCreateStep
) => Object.values(steps).findIndex(({id}) => id === currentStep)
